import { render } from "./AddLeadsToCRM.vue?vue&type=template&id=28f0c430&scoped=true"
import script from "./AddLeadsToCRM.vue?vue&type=script&lang=js"
export * from "./AddLeadsToCRM.vue?vue&type=script&lang=js"

import "./AddLeadsToCRM.vue?vue&type=style&index=0&id=28f0c430&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f0c430"]])

export default __exports__